export default __webpack_public_path__ + "static/media/wallets.d3e045a9.jpg";